angular.module('shared').directive('input', ["$timeout", function($timeout) {
  return {
    restrict: 'E',
    link: function(scope, element, attrs) {
      if (attrs.type === 'number') {
        element.bind('keydown', function(event) {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            return element[0].blur();
          }
        });
        return element.bind('wheel', function(event) {
          if (document.activeElement === element[0]) {
            element[0].blur();
            event.stopPropagation();
            return $timeout(function() {
              return element[0].focus();
            });
          }
        });
      }
    }
  };
}]);
